import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import {
  AUTH0_DOMAIN,
  AUTH0_REDIRECT_URI,
  AUTH0_AUDIENCE,
  AUTH0_CLIENTID,
} from '#config/auth0Config';

import AuthProvider from './Auth0Provider';

const Auth0: React.FC<any> = (props) => (
  <Auth0Provider
    domain={AUTH0_DOMAIN}
    clientId={AUTH0_CLIENTID}
    authorizationParams={{
      audience: AUTH0_AUDIENCE,
      redirectUri: AUTH0_REDIRECT_URI,
    }}
  >
    <AuthProvider {...props} />
  </Auth0Provider>
);

export default Auth0;
